import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loaderSubject = new BehaviorSubject<boolean>(false);
  readonly loader$ = this.loaderSubject.asObservable();

  public showLoader(): void {
    this.loaderSubject.next(true);
  }

  public hideLoader(): void {
    this.loaderSubject.next(false);
  }
}
